module.exports = __webpack_public_path__ + "img/Isibaniro 400.a19c5dea.png";